/** @jsx jsx */
import { jsx } from  '@emotion/core'
import NumberFormat from 'react-number-format';
// import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import t from '../i18n'
import { Table, Select, Row, Col, Switch, Button, Space } from 'antd';

const { Option } = Select;
import ReactDragListView from 'react-drag-listview'
import removeTrailingZeros from 'remove-trailing-zeros'

import React, { Component } from 'react';
import { ReloadOutlined, FileExcelOutlined } from '@ant-design/icons'
import StockLocations from './stock_locations'
import { VariantList } from './VariantList';
import StockHistory from './stock_history'
const tableCSS = {
  '& thead > tr > th': {
    cursor: 'move !important',

  },
  '& tr > td, tr.footer > th': {
    "text-align": "right"
  }
};

const DescriptionItem = ({ title, content }) => (
  <div className="site-description-item-profile-wrapper">
    <p className="site-description-item-profile-p-label">{title}:</p>
    {content}
  </div>
);

export default class StockReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: [],
      stockLocations: [],
      selectedStockLocations: null,
      variantList: [],
      filteredInfo: null,
      columns: [],
      showInStock: true,
      variantData: {},
      showHistory: false,
    }

    const that = this;
    this.dragProps = {
      onDragEnd(fromIndex, toIndex) {
        const columns = that.state.columns;
        const item = columns.splice(fromIndex, 1)[0];
        columns.splice(toIndex, 0, item);
        that.setState({
          columns
        });
      },
      nodeSelector: "th"
    };

    
  }

  componentDidMount = () => {
    this.loadData();
  }

  loadData = (callback) => {
    const $this = this
    $this.setState({
      loading: true
    });

    $.ajax({
      type: "get",
      dataType: 'json',
      url: Biscraft.routes.reports.stock_report + `?show_in_stock=${this.state.showInStock}`,
      data: {
        token: Spree.api_key
      },
      success: function (stock_details) {
     
        const data = []
        stock_details.data.forEach( d => 
           {
            try {
              const row = JSON.parse(d.data)
              const { variant_id, variant_name, variant_name_ar } = d
              data.push({ data: row, variant_id, variant_name, variant_name_ar })

            } catch (error) {
              debugger
            }

            }
          )


        $this.setState({
          loading: false,
          data,
          stockLocations: stock_details.stock_locations,
        }, () => $this.setState({columns: $this.getColumns($this.state.selectedStockLocations)}));
        if (callback) callback();

      }
    });
  }

  stockLocationChangedHandler = (locations) => {
    this.setState({ selectedStockLocations: locations })
    this.setState({columns: this.getColumns(locations)})
  }

  variantChangedHandler = (variants) => {
    let { filteredInfo } = this.state
    filteredInfo = filteredInfo || {}

    const ids = variants.map( v => v.id)
    filteredInfo.item = ids;
    this.setState({ filteredInfo }, function () { this.setState({ columns: this.getColumns(this.state.stockLocations) }) })


  }

  variantList = () => {
    return this.state.data.map((d) => ({ name: d.variant_name, id: d.variant_id}) )
  }

handleChange = (pagination, filters, sorter) => {

  this.setState({
    filteredInfo: filters,
    sortedInfo: sorter,
  });
};

loadHistory = (variantData, locationData) => {

  this.setState({ showHistory: true, variantData, locationData }) 

}

  
getColumns = (locations) => {

  const locs = locations && locations.length > 0 ? locations : this.state.stockLocations

  let { filteredInfo } = this.state;
  filteredInfo = filteredInfo || {};
   
  let cols = 
  [
    {
      title: <div className="text-right"> # </div> ,
      width: 50,
      render: (text, record, index) => index + 1
    },
    {
      title: t('item'),
      width: 250,
      align: "left",
      dataIndex: 'variant_name',
      filters: [
        {
          text: 'POS Item',
          value: 'is_pos_item',
        },
        {
          text: 'Inventory Item',
          value: 'is_inventory_item',
        },
      ],
      // specify the condition of filtering result
      // here is that finding the name started with `value`
      filteredValue: filteredInfo.item || null,
      // filterDropdown: () => <div>This should be a filter doc</div>,
      onFilter: (value, record) => value == record.variant_id,

      sorter: (a, b) => { return (a.item && b.item) ?  (a.item.length - b.item.length) : 0},
      sortDirections: ['descend', 'ascend'],
      render: (text, record) => (<a className="pull-left" href="#" onClick={() => this.loadHistory(record)}> <span style={{ fontSize: '0.7em' }}>{record.variant_name} {record.variant_id} </span> <span><br/>{record.variant_name_ar} </span> </a>)
      },
    {
      title: <div className="text-right"> {t('qty')} </div>,
      dataIndex: 'qty',
      render: (text, record) => {
        const qty = Object.keys(record.data).map((locationid) => (parseFloat(record.data[locationid]))).reduce((total, num) => total + num, 0.0)
        return isNaN(qty) ? "" : removeTrailingZeros(qty.toFixed(2))
 
      },
      defaultSortOrder: 'descend',
      sorter: (a, b) => a.age - b.age,
    },
    {
      title: <div className="text-right pull-right"> {t('total_cost')} </div>,
        dataIndex: 'cost',
        render: (text, record) => {
          const cost = 0.0 // record.stock_detail.map((stock_data) => (parseFloat(stock_data.cost_price))).reduce((total, num) => total + num, 0.0)
          return isNaN(cost) ? "" : cost.toFixed(2)
        },
        defaultSortOrder: 'descend',
        sorter: (a, b) => a.age - b.age,

    }
  ]

    cols = cols.concat( locs.map( (loc) =>  (
    {
        title: <div className="text-right" style={{ fontSize: '0.8em' }}> {loc.name} </div> ,
      dataIndex: loc.id,
      ellipsis: {
        showTitle: true,
      },
      key: loc.id,
      render: (text, record) => {
        const stock = record.data[loc.id];
        return <a href='#' onClick={() => this.loadHistory(record, loc)}>  {(stock ? removeTrailingZeros(stock) : formatNumber(stock))} </a>
      } 
            
    })

  ) )
  
  return cols;
  
  }

  refresh = () => {
    this.setState({ refreshing: true})
    this.loadData(() => { this.setState({ refreshing: false })})

  }

  switchData = (checked) => {
    if (checked ){
      this.setState({ showInStock: true }, () => this.loadData())
    }
    else{
     this.setState({ showInStock: false }, () => this.loadData())
    }
  }


  getDataColumns = () => {
    const { stockLocations } = this.state;
    let dCols = [
      { name: t('item'), totalsRowLabel: 'Totals:', filterButton: true },
      { name: t('qty'), totalsRowFunction: 'sum', filterButton: false },
    ];


    dCols = dCols.concat(stockLocations.map((loc) => ({ key: loc.id, name: loc.name, totalsRowFunction: 'sum', filterButton: true })));


    return [dCols];
    dCols.push(locs.map((loc) => ({ name: loc.name, totalsRowFunction: 'sum', filterButton: true })))
    render: (stock, variant) => {
      return <a href='#' onClick={() => this.loadHistory(variant, loc)}>  {(stock ? removeTrailingZeros(stock) : formatNumber(stock))} </a>;
    }
  }

  downloadExcel = () => {
    const [columns] = this.getDataColumns()
    const data  = this.state.data


// debugger
    // const qty = record.stock_detail.map((stock_data) => (parseFloat(stock_data.count_on_hand))).reduce((total, num) => total + num, 0.0)
    // debugger
    const { stockLocations } = this.state;

    let rows = []
    
    data.forEach(d => {
      let row = [d.variant_name, 
      Object.keys(d.data).map((locId) => (parseFloat(d.data[locId]))).reduce((total, num) => total + num, 0.0)];
      stockLocations.forEach(sl => {
        const val = d.data[sl.id]
        row.push(val ? removeTrailingZeros(val) : null );
      })
      rows.push(row)
    })

  


    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Trial Balance',
      {
        views: [{ showGridLines: false }],
        headerFooter: { firstHeader: "Trial Balance", firstFooter: "Biscraft Powered" },
        style: {
          font: {
            name: 'Calibri',
            family: 4,
            size: 16,
          }
        },
      }
    );
    // worksheet.properties.defaultRowHeight = 15;
    // worksheet.getCell('A1').note = 'Hello, ExcelJS!';
    const table = worksheet.addTable({
      name: 'TrialBalance',
      displayName: 'Stock Report As On ' + moment(this.state.date).format('lll'),
      ref: 'A1',
      headerRow: true,
      totalsRow: true,
      width: 50,

      style: {
        // theme: 'TableStyleDark3',
        showRowStripes: true,
        font: {
          name: 'Calibri',
          family: 4,
          size: 30,
          underline: true,
          bold: true
        }
      },
      columns ,
      rows,
    });

    const font = { name: 'Calibri', size: 12 };

    var nameCol = worksheet.getColumn(1);
    var typeCol = worksheet.getColumn(2);
    var debitCol = worksheet.getColumn(3);
    var creditCol = worksheet.getColumn(4);

    // [nameCol, typeCol, debitCol, creditCol].forEach(col => {
    //   col.width = 25;
    //   col.font = font;
    // });
    nameCol.width = 40;
    nameCol.alignment = { wrapText: true };

    // debitCol.eachCell(function (cell, rowNumber) {
    //   // ...
    // });
    debitCol.numFmt = '""#,##0.00;[Red]\-""#,##0.00';
    creditCol.numFmt = '""#,##0.00;[Red]\-""#,##0.00';
    table.commit();


    const filename = 'trial_balance_';
    return workbook.xlsx.writeBuffer().then(function (buffer) {
      saveAs(new Blob([buffer], {
        type: "application/octet-stream"
      }), `${filename}-${moment().format('YYYY-MM-DD__HH:mm:ss')}.xlsx`);
    });
  }

  render() {
    // alert(_global_currency_code)
    const { data, stockLocations, selectedStockLocations, columns } = this.state
    const locations = selectedStockLocations || stockLocations

    return (
      <div>

        <StockHistory 
          historyItems = {[1,2,3,4]}
          showHistory= {this.state.showHistory}
          onClose={ () => this.setState({ showHistory: false })}
          variantData = { this.state.variantData }
          locationData = { this.state.locationData }
        />
        
        <Row gutter={14} style={{marginBottom: '10px'}}>
      
          <Col span={8}>
            <StockLocations
              StockLocationChanged={this.stockLocationChangedHandler}
              stockLocations={stockLocations}
            />
          </Col>
          <Col span={8}>
            <VariantList
              VariantChanged={this.variantChangedHandler}
              variantList={this.variantList()}
            />
          </Col>  
          <Col span={8}>
            <Space>
              <Switch checkedChildren={<span>{t('in_stock')}</span>}
               unCheckedChildren="All" 
               defaultChecked 
                onChange={(checked) => { this.switchData(checked) }}
               
               />
        

              <Button disabled={! data?.length > 0 } onClick={this.downloadExcel} icon={<FileExcelOutlined />} type="primary" > Download </Button>

              <Button loading={this.state.refreshing} onClick={this.refresh} icon={<ReloadOutlined  />}></Button>
            </Space>
          </Col>          
          
        </Row>
             
          <Table 
            id="table-to-xls"
            columns={ columns} 
            dataSource={data} 
            pagination={false}
            rowKey="id"
            size = {"small"}
            css={tableCSS}
            bordered
            loading = {this.state.loading}
            onChange={this.handleChange}
            summary={pageData => {
              let totalQty = 0.0;
              let totalCost = 0.0;

              pageData.forEach(({ data }) => {
                
                totalQty += Object.keys(data).map((locationId) => (parseFloat(data[locationId]))).reduce((total, num) => total + num, 0.0);
                // totalCost += data.map((stock_data) => (parseFloat(stock_data.cost_price))).reduce((total, num) => total + num, 0.0);
              });
              
              return (

                <tr style={{ position: "sticky", bottom: 0, background: "#FFF" }} className="footer"  >
                    <th></th>
              <th>{t('total')}</th>
                  <th style={{ fontSize: '0.7em' }}>
                      {( totalQty.toFixed(2))}
                    </th>
                  <th style={{ fontSize: '0.7em' }}>
                    {totalCost.toFixed(2)}
                    {/* <NumberFormat value={totalCost.toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={_global_currency_code} /> */}


                    </th>
                  {locations.map( elm => {
                      return (<th style={{fontSize: '0.7em'}}>
                        {(pageData.filter(d => { return d.data[elm.id] ? true : false}).map((d) => (parseFloat(d.data[elm.id]))).reduce((total, num) => total + num, 0.0).toFixed(2)) }
                      </th>)
                  }

                  )}
                  </tr>


              );
            }}
                      // table end
                    />


      </div>
    )
  }
}









